"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BanList = exports.ALL_RULE_TYPES = exports.SERVER_RULE_TYPES = exports.ROOM_RULE_TYPES = exports.USER_RULE_TYPES = exports.RULE_SERVER = exports.RULE_ROOM = exports.RULE_USER = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require("bluebird");

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

exports.ruleTypeToStable = ruleTypeToStable;

var _ListRule = require("./ListRule");

var _MatrixClientPeg = require("../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

// Inspiration largely taken from Mjolnir itself

var RULE_USER = exports.RULE_USER = "m.room.rule.user";
var RULE_ROOM = exports.RULE_ROOM = "m.room.rule.room";
var RULE_SERVER = exports.RULE_SERVER = "m.room.rule.server";

var USER_RULE_TYPES = exports.USER_RULE_TYPES = [RULE_USER, "org.matrix.mjolnir.rule.user"];
var ROOM_RULE_TYPES = exports.ROOM_RULE_TYPES = [RULE_ROOM, "org.matrix.mjolnir.rule.room"];
var SERVER_RULE_TYPES = exports.SERVER_RULE_TYPES = [RULE_SERVER, "org.matrix.mjolnir.rule.server"];
var ALL_RULE_TYPES = exports.ALL_RULE_TYPES = [].concat(USER_RULE_TYPES, ROOM_RULE_TYPES, SERVER_RULE_TYPES);

function ruleTypeToStable(rule) {
    var unstable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (USER_RULE_TYPES.includes(rule)) {
        return unstable ? USER_RULE_TYPES[USER_RULE_TYPES.length - 1] : RULE_USER;
    }
    if (ROOM_RULE_TYPES.includes(rule)) {
        return unstable ? ROOM_RULE_TYPES[ROOM_RULE_TYPES.length - 1] : RULE_ROOM;
    }
    if (SERVER_RULE_TYPES.includes(rule)) {
        return unstable ? SERVER_RULE_TYPES[SERVER_RULE_TYPES.length - 1] : RULE_SERVER;
    }
    return null;
}

var BanList = exports.BanList = function () {
    function BanList(roomId) {
        (0, _classCallCheck3.default)(this, BanList);
        this._rules = [];

        this._roomId = roomId;
        this.updateList();
    }

    (0, _createClass3.default)(BanList, [{
        key: "banEntity",
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(kind, entity, reason) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().sendStateEvent(this._roomId, ruleTypeToStable(kind, true), {
                                    entity: entity,
                                    reason: reason,
                                    recommendation: (0, _ListRule.recommendationToStable)(_ListRule.RECOMMENDATION_BAN, true)
                                }, "rule:" + entity));

                            case 2:
                                this._rules.push(new _ListRule.ListRule(entity, _ListRule.RECOMMENDATION_BAN, reason, ruleTypeToStable(kind, false)));

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function banEntity(_x2, _x3, _x4) {
                return _ref.apply(this, arguments);
            }

            return banEntity;
        }()
    }, {
        key: "unbanEntity",
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(kind, entity) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().sendStateEvent(this._roomId, ruleTypeToStable(kind, true), {}, "rule:" + entity));

                            case 2:
                                this._rules = this._rules.filter(function (r) {
                                    if (r.kind !== ruleTypeToStable(kind, false)) return true;
                                    if (r.entity !== entity) return true;
                                    return false; // we just deleted this rule
                                });

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function unbanEntity(_x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return unbanEntity;
        }()
    }, {
        key: "updateList",
        value: function updateList() {
            this._rules = [];

            var room = _MatrixClientPeg2.default.get().getRoom(this._roomId);
            if (!room) return;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(ALL_RULE_TYPES), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var eventType = _step.value;

                    var events = room.currentState.getStateEvents(eventType, undefined);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(events), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var ev = _step2.value;

                            if (!ev.getStateKey()) continue;

                            var kind = ruleTypeToStable(eventType, false);

                            var entity = ev.getContent()['entity'];
                            var recommendation = ev.getContent()['recommendation'];
                            var reason = ev.getContent()['reason'];
                            if (!entity || !recommendation || !reason) continue;

                            this._rules.push(new _ListRule.ListRule(entity, recommendation, reason, kind));
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "roomId",
        get: function get() {
            return this._roomId;
        }
    }, {
        key: "serverRules",
        get: function get() {
            return this._rules.filter(function (r) {
                return r.kind === RULE_SERVER;
            });
        }
    }, {
        key: "userRules",
        get: function get() {
            return this._rules.filter(function (r) {
                return r.kind === RULE_USER;
            });
        }
    }, {
        key: "roomRules",
        get: function get() {
            return this._rules.filter(function (r) {
                return r.kind === RULE_ROOM;
            });
        }
    }]);
    return BanList;
}();
//# sourceMappingURL=BanList.js.map